export default __webpack_public_path__ + "static/media/welcome_img.a9fd84b6.png";